import { subscribe, getState, addLocationLocal, updateLocationLocal } from '../state/store.js';
import { createLocation, updateLocation, renameLocationOnCharacters } from '../services/supabase.js';

const locationsTabAddBtn = document.getElementById('locationsTabAddBtn');
const locationFormModal = document.getElementById('locationFormModal');
const locationForm = document.getElementById('locationForm');
const locationFormCancel = document.getElementById('locationFormCancel');
const locationFormTitle = document.getElementById('locationFormTitle');
const locationsListBody = document.getElementById('locationsListBody');
const locationsSearchInput = document.getElementById('locationsSearchInput');

let locationsSearchTerm = '';

const escapeHTML = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const openLocationForm = () => {
  locationForm?.reset();
  if (locationForm) delete locationForm.dataset.editLocationId;
  if (locationFormTitle) locationFormTitle.textContent = 'Add Location';
  locationFormModal?.showModal();
};

const openLocationFormForEdit = (location) => {
  locationForm?.reset();
  if (locationForm) {
    locationForm.dataset.editLocationId = String(location.id);
    locationForm.elements['location_name'].value = location.name || '';
    locationForm.elements['hex_number'].value = location.hexNumber || '';
    locationForm.elements['disease_modifier'].value = location.diseaseModifier || '';
    locationForm.elements['parasite_modifier'].value = location.parasiteModifier || '';
    locationForm.elements['notes'].value = location.notes || '';
  }
  if (locationFormTitle) locationFormTitle.textContent = 'Edit Location';
  locationFormModal?.showModal();
};

const closeLocationForm = () => locationFormModal?.close();

const handleLocationSubmit = async (event) => {
  event.preventDefault();
  const formData = Object.fromEntries(new FormData(locationForm).entries());
  const name = String(formData.location_name || '').trim();
  if (!name) {
    alert('Location name is required.');
    return;
  }
  const editId = locationForm.dataset.editLocationId ? Number(locationForm.dataset.editLocationId) : null;
  try {
    if (editId) {
      const existing = getState().locations.find((location) => location.id === editId);
      const updated = await updateLocation(editId, formData);
      if (existing) await renameLocationOnCharacters(existing.name, updated.name);
      updateLocationLocal(editId, updated);
      closeLocationForm();
    } else {
      const created = await createLocation(formData);
      addLocationLocal(created);
      closeLocationForm();
    }
  } catch (error) {
    alert(`Failed to save location: ${error.message}`);
  }
};

const renderLocationsList = () => {
  if (!locationsListBody) return;
  const { locations } = getState();
  const term = locationsSearchTerm.trim().toLowerCase();
  const filtered = term
    ? locations.filter((location) => (location.name || '').toLowerCase().includes(term))
    : locations;
  const sorted = filtered
    .slice()
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
  locationsListBody.innerHTML = sorted.length
    ? sorted
        .map((location) => {
          const meta = [
            location.hexNumber ? `Hex ${escapeHTML(location.hexNumber)}` : '',
            location.diseaseModifier ? `Disease ${escapeHTML(String(location.diseaseModifier))}%` : '',
            location.parasiteModifier ? `Parasite ${escapeHTML(String(location.parasiteModifier))}%` : ''
          ]
            .filter(Boolean)
            .join(' &middot; ');
          const notes = escapeHTML(location.notes);
          return `<div class="locations-list-row" data-id="${location.id}" role="button" tabindex="0">
            <div class="loc-main">
              <div>${escapeHTML(location.name || 'Unnamed')}</div>
              ${meta ? `<div class="muted">${meta}</div>` : ''}
              ${notes ? `<div class="loc-notes-preview">${notes}</div>` : ''}
            </div>
          </div>`;
        })
        .join('')
    : '<p class="placeholder">No locations yet.</p>';
};

const openLocationFromRow = (row) => {
  const location = getState().locations.find((l) => l.id === Number(row.dataset.id));
  if (location) openLocationFormForEdit(location);
};

export const initLocations = () => {
  locationsTabAddBtn?.addEventListener('click', openLocationForm);
  locationForm?.addEventListener('submit', handleLocationSubmit);
  locationFormCancel?.addEventListener('click', closeLocationForm);
  locationsSearchInput?.addEventListener('input', (event) => {
    locationsSearchTerm = event.target.value;
    renderLocationsList();
  });

  locationsListBody?.addEventListener('click', (event) => {
    const row = event.target.closest('.locations-list-row');
    if (row) openLocationFromRow(row);
  });
  locationsListBody?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const row = event.target.closest('.locations-list-row');
    if (!row) return;
    event.preventDefault();
    openLocationFromRow(row);
  });

  subscribe(renderLocationsList);
};
